import React, { useEffect, useState, useContext } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import StoreInfo from '../../parts/StoreInfo';
import { getApiData } from '../../../services/apiService';
import ProfileContext from '../../../services/profileContext';

export default function CustomerSOAPrintView (){
    const {
        account
    } = useContext(ProfileContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', '₱');
    const { contact_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState([]);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [load_status, setStatus] = useState(0);
    //const [account, setAccount] = useState([]);
   
    useEffect(() => {
        initTreeView()
        
        const customer_id = helpers.getURLParams('customer_id');
        const request_from = helpers.getURLParams('request_from');
        const request_to = helpers.getURLParams('request_to');
        fetchData()
    }, []);

    useEffect(() => {
        if(load_status){
            setTimeout(function(){
                //window.print()
            }, 2000);
        }
    }, [load_status]);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    // async function fetchAccount(){
    //     let endpoint = helpers.createUrl(`V1/account/profile`)
    //     const res = await getApiData(endpoint)

    //     if(res){
    //         setAccount(res.data)
    //         //setAccountLoaded(1)
            
    //         fetchData()
    //     }
                
    //     if(res.status === 'error'){
    //         setLoading(0)
    //         Swal.fire({
    //             text: res.message,
    //             icon: "error",
    //             confirmButtonText: "OK",
    //             allowOutsideClick: false
    //         })
    //         .then((result) => {
    //             if (result.isConfirmed) {
    //                 window.location.replace("/customers/list");
    //             }
    //         })
    //     }
    // }


    async function fetchData(){
        // const customer_id = helpers.getURLParams('customer_id');
        // const request_from = helpers.getURLParams('request_from');
        // const request_to = helpers.getURLParams('request_to');

        // const param_keys = {
        //     customer_id: customer_id,
        //     request_from: request_from,
        //     request_to: request_to
        // }

        // console.log('dito')

        // const params = helpers.generateUrlParams(param_keys)

        //let endpoint = helpers.createShipBookingHubUrl(`booking/soa/${params}`)
        let endpoint = helpers.createUrl(`V1/manage/contact/${contact_id}?expand=outstanding-invoice&store_id=${helpers.getStoreID()}`)
        
        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            setRecordData(res)
            setRecordItems(res.outstanding_invoice)
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/customers/list");
                }
            })
        }
    }

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                let counter = parseInt(key) + 1
                return(
                    <>
                        <tr>
                            {/* <td>{counter}</td> */}
                            <td>{data?.invoice_no}</td>
                            <td>{formatDate(data?.invoice_date)}</td>
                            <td>{data?.due_date ? formatDate(data?.due_date) : '---'}</td>
                            <td>{helpers.formatCurrencyAmount(data?.total_amount)}</td>
                            <td>{helpers.formatCurrencyAmount(parseFloat(data?.total_amount) - parseFloat(data?.balance_amount))}</td>
                            <td>{helpers.formatCurrencyAmount(data?.balance_amount)}</td>
                        </tr>
                    
                        <tr>
                        </tr>
                    </>
                )
            })

            // items.push(
            //     <tr>
            //         <th className='bg-light text-right' colSpan={5}>Total Amount Due</th>
            //         <th className='bg-light'>
            //             {helpers.formatCurrencyAmount(computeTotalInvoiced())}
            //         </th>
            //     </tr>
            // )
        }
        else{
            items =  
                    <tr>
                        <td colSpan={10} className='text-center'>No data to display.</td>
                    </tr>
        }


        setTableItems(<tbody>{items}</tbody>)
        setStatus(1)
    }

    function computeSubTotals(){
        // let items = 0;
        // let total_amount = 0
        // Object.entries(record_items).map(([key, data]) => {
        //     items = items + Number(data.quantity)
        //     total_amount = total_amount + parseInt(data.quantity) * parseFloat(data.amount)
        // });

        // return helpers.formatCurrencyAmount(total_amount);
    }

    function formatDateTime(date = '') {
        let now = new Date();
        if(!date){
            let now = new Date(date);
        }

        // 1. Format the Date: "14 May 2026"
        const datePart = new Intl.DateTimeFormat('en-US', {
            month: 'long',
            day: '2-digit',
            year: 'numeric'
        }).format(now);

        // 2. Format the Time: "02:28:31PM"
        const timePart = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        }).format(now).replace(/\s/g, '');

        // 3. Combine with a comma
        return `${datePart}`;
    }

    function formatDate(dateString) {
        if (!dateString) return "";
        
        // Create a date object (handles 'YYYY-MM-DD' safely)
        const date = new Date(dateString);
        
        // Check if the date is valid
        if (isNaN(date.getTime())) return "Invalid Date";

        // Format the date using Intl.DateTimeFormat
        return new Intl.DateTimeFormat('en-US', {
            month: 'long',   // "June"
            day: '2-digit',  // "01" (forces the leading zero)
            year: 'numeric'  // "2026"
        }).format(date);
    }

    function computeTotalInvoiced() {
        return record_items.reduce((sum, item) => {
            // Use parseFloat to convert the string "20000.00" to a number
            // and ensure we don't accidentally do string concatenation.
            const amount = parseFloat(item.total_amount) || 0;
            return sum + amount;
        }, 0);
    }

    function calculateTotalBalance() {
        return record_items.reduce((sum, item) => {
            // Use parseFloat to convert the string "20000.00" to a number
            // and ensure we don't accidentally do string concatenation.
            const amount = parseFloat(item.balance_amount) || 0;
            return sum + amount;
        }, 0);
    }

    function computeTotalPaid() {
        return record_items.reduce((sum, invoice) => {
            const total = parseFloat(invoice.total_amount) || 0;
            const balance = parseFloat(invoice.balance_amount) || 0;
            
            // Calculate paid for this invoice and add it to the running sum
            return sum + (total - balance);
        }, 0); // Starts the sum at 0
    }


    return (
        <div className="invoice p-4 mb-3">
            <Loader isLoading={loading}/>

            <div className="d-flex justify-content-between mb-3">
                <StoreInfo store={record_data.store_info} />
                {/* <div>
                    <p className='mb-0'><b>San Ricardo Shipping Lines Corp.</b></p>
                    <p className='mb-0' style={{fontSize: '14px'}}>www.sanricardoshipping.com</p>
                    <p className='mb-0' style={{fontSize: '14px'}}>Port Area, Brgy. Benit, San Ricardo, Southern Leyte 6617</p>
                </div> */}
                <div>
                    <h5 className='text-center'><strong>Statement of Account (SOA)</strong></h5>
                </div>
            </div>

            <hr/>

            <div className="d-flex justify-content-between mb-3">
                <div>
                    <p className='mb-0'>Customer: <b>{record_data?.contact_name ? record_data?.contact_name : 'N/A'}</b></p>
                    <p className='mb-0'>Date: <b>{formatDateTime()}</b></p>
                    {/* <p className='mb-0'>Generated Date: {helpers.getCurrentDateTime()}</p> */}
                </div>
                {/* <div>
                    <p className='mb-0'>Generated Date: <b>{formatDateTime()}</b></p>
                </div> */}
            </div>

            <div className='table-responsives'>
                <table className='table table-bordered table-stripeds table-sm border-bottom'>
                    <thead class="thead-dark">
                        <tr>
                            {/* <th>No.</th> */}
                            <th>Invoice No</th>
                            <th>Invoice Date</th>
                            <th>Due Date</th>
                            <th>Amount</th>
                            <th>Paid</th>
                            <th>Balance</th>
                        </tr>
                    </thead>
                    {
                        table_items
                    }
                </table>
            </div>
            
            <div className='row'>
                <div className="col-7 d-flex align-items-center">{record_data.customer_notes ? <p className='pt-1 pt-lg-4'>{record_data.customer_notes}</p>:''}</div>
                <div className="col-5 mb-2 border p-2">
                    <table className='table table-sm table-borderless mb-0'>
                        <tbody>
                            <tr>
                                <td className='border-top-0'><b>Total Invoiced</b></td>
                                <td className='border-top-0'>{helpers.formatCurrencyAmount(computeTotalInvoiced())}</td>
                            </tr>
                            <tr>
                                <td className='border-top-0'><b>Total Paid</b></td>
                                <td className='border-top-0'>{helpers.formatCurrencyAmount(computeTotalPaid())}</td>
                            </tr>
                            <tr className='bg-dark'>
                                <td><b>Total Outstanding Balance</b></td>
                                <td>{helpers.formatCurrencyAmount(calculateTotalBalance())}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>Generated Date: {helpers.getCurrentDateTime()}</small><br/>
                    <small>This is a system-generated report. Powered by Topventory.</small>
                </div>
            </div>
        </div>
    )
}